import React from "react";
import PenIcon from "@/assets/pen.png";
import { PlanData } from "@/types/summary";

interface PlanSectionProps {
  data: PlanData[];
  onEdit: () => void;
}

const PlanSection: React.FC<PlanSectionProps> = ({ data, onEdit }) => {
  return (
    <div className="p-[20px]">
      <div className="flex justify-between items-center mb-[16px]">
        <h3 className="text-[1.125rem]">Plan</h3>
        <button
          onClick={onEdit}
          className="text-[#00ADAC] hover:text-[#008281] text-[1.125rem] cursor-pointer border-none bg-transparent flex items-center gap-1"
        >
          <img src={PenIcon} className="w-[18px] h-[18px]" alt="Edit" />
          Edit
        </button>
      </div>

      <div className="space-y-[12px]">
        {data.map((plan) => (
          <div key={plan.minorAccountID}>
            <p className="text-[16px]">
              {plan.beneficiaryName}: Target enrollment{" "}
              {plan.academicTargetYear || "TBD"}{" "}
              {plan.planType === "recommendation" ? "(Recommended)" : ""}
            </p>
          </div>
        ))}
        {data.length === 0 && (
          <div className="text-center text-[#8B8B8B]">
            <p>No investment plans selected yet.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default PlanSection;
